const riskOptions = [
  { key: 'risk1', text: 'Indefinido', value: 'Indefinido' },
  { key: 'risk2', text: 'Baixo', value: 'Baixo' },
  { key: 'risk3', text: 'Médio', value: 'Médio' },
  { key: 'risk4', text: 'Alto', value: 'Alto' },
  { key: 'risk5', text: 'Muito Alto', value: 'Muito Alto' },
]
export default riskOptions
